/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import LoadingProgress from 'data/utils/reducers/loading';
import Pagination from 'data/utils/reducers/pagination';

export const itemsPagination = new Pagination('wechatInviteToken');
export const listLoadingProgress = new LoadingProgress('wechatInviteTokenList');

const mergeData = (state, payload) =>
  state.withMutations((newState) => {
    const { entities } = payload;
    if (entities && entities.wechatInviteTokens) {
      newState.mergeIn(['entities'], fromJS(entities.wechatInviteTokens));
    }
  });

const loadList = (state, action) =>
  state.withMutations((newState) => {
    const { result, total } = action.payload;
    mergeData(newState, action.payload);
    itemsPagination.set(newState, total, result.length, fromJS(result));
    listLoadingProgress.setLoaded(newState);
  });

const clear = (state) =>
  state.withMutations((newState) => {
    listLoadingProgress.clear(newState);
    itemsPagination.clear(newState);
  });

const initialState = fromJS({
  entities: {},
});

const wechatInviteTokens = (state = initialState, action) => {
  switch (action.type) {
    case 'WECHAT_INVITE_TOKENS_FETCH_START':
      return listLoadingProgress.setLoading(state);

    case 'WECHAT_INVITE_TOKENS_FETCH_SUCCESS':
      return loadList(state, action);

    case 'WECHAT_INVITE_TOKENS_FETCH_FAILED':
      return listLoadingProgress.setLoadFailed(state);

    case 'WECHAT_INVITE_TOKENS_CREATE_START':
      return listLoadingProgress.setLoading(state);

    case 'WECHAT_INVITE_TOKENS_CREATE_SUCCESS':
      return loadList(state, action);

    case 'WECHAT_INVITE_TOKENS_CREATE_FAILED':
      return listLoadingProgress.setLoadFailed(state);

    case 'WECHAT_INVITE_TOKENS_CLEAR':
      return clear(state);

    default:
      return state;
  }
};

export default wechatInviteTokens;
